// extracted by mini-css-extract-plugin
module.exports = {"list":"InvoiceCustomize_list__T1Ooe","item":"InvoiceCustomize_item__mKNkM"};